import CatalogImage from 'components/MediaServerImage/CatalogImage';
import NavLink from 'components/NavLink';
import PlayButtonContainer from 'components/Player/PlayButtonContainer';
import PlayButtonContainerPrimitive from 'components/Artist/PlayButtonContainer';
import PlayerStateProxy from 'components/Player/PlayerState/PlayerStateProxy';
import Tile from 'components/Tile/Tile';
import Tiles from 'components/Tiles/Tiles';
import TilesImageWrapper from 'components/Tile/primitives/TilesImageWrapper';
import type { Data as ItemSelectedData } from 'modules/Analytics/helpers/itemSelected';
import type { PlaybackTypeValue } from 'constants/stationTypes';
import type { Station } from 'state/Stations/types';

type Props = {
  customRadioEnabled: boolean;
  forYouStations: Array<Station>;
  hasBottomMargin: boolean;
  imgWidth: number;
  itemSelectedLocation: string;
  playedFrom: number;
  singleRow?: boolean;
  tilesInRow: number;
};

const PlayButton = PlayerStateProxy(PlayButtonContainer);

function ForYouTiles({
  customRadioEnabled,
  forYouStations,
  hasBottomMargin,
  imgWidth,
  itemSelectedLocation,
  playedFrom,
  singleRow = false,
  tilesInRow,
}: Props) {
  if (!forYouStations.length) return null;
  return (
    <Tiles tilesInRow={tilesInRow}>
      {forYouStations.map(
        ({ callLetters, imgUrl, seedId, seedType, title, url }) => {
          const itemSelected = {
            id: seedId,
            location: itemSelectedLocation,
            name: callLetters || title,
            type: seedType as PlaybackTypeValue,
          } as ItemSelectedData;

          return (
            <Tile
              hasBottomMargin={hasBottomMargin}
              itemSelected={itemSelected}
              key={seedId}
              singleRow={singleRow}
              subTitle
              tilesInRow={tilesInRow}
              title={title}
              titleSingleLine
              url={url}
            >
              <NavLink itemSelected={itemSelected} to={url}>
                {customRadioEnabled && (
                  <PlayButtonContainerPrimitive>
                    <PlayButton
                      artistName={title}
                      className="play"
                      deferPlay={url}
                      playedFrom={playedFrom}
                      seedId={seedId}
                      stationId={seedId}
                      stationType={seedType}
                    />
                  </PlayButtonContainerPrimitive>
                )}
                <TilesImageWrapper liveTile={seedType === 'live'}>
                  <CatalogImage
                    alt={title ?? ''}
                    aspectRatio={1}
                    height={imgWidth}
                    id={seedId}
                    src={imgUrl}
                    type={seedType}
                    width={imgWidth}
                  />
                </TilesImageWrapper>
              </NavLink>
            </Tile>
          );
        },
      )}
    </Tiles>
  );
}

export default ForYouTiles;
